<template>

    <div class="layout__container text__align-center">
        <div class="layout__padding-clear">


            <!--<h3 class="textAlignCenter red padding">No matching results</h3>-->
            <h3 class="layout__padding-20-0 text__colour-red">We're sorry </h3>

            <div v-show="issue === 'types'">
                <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
                <h3 class="layout__padding-20-0">No matching paper type results for selections:</h3>
                <p>Product: {{printJob.printJobSpec.name}}</p>
            </div>

            <div v-show="issue === 'weights'">
                <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
                <h3 class="layout__padding-20-0">No matching paper weight results for selections:</h3>
                <p>Product: {{printJob.printJobSpec.name}}</p>
                <p>Paper Weight: {{printJob.printJobSpec.stockWeight}}</p>
            </div>

            <div v-show="issue === 'laminations'">
                <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
                <h3 class="layout__padding-20-0">No matching lamination results for selections:</h3>
                <p>Product: {{printJob.printJobSpec.name}}</p>
                <p>Paper Weight: {{printJob.printJobSpec.stockWeight}}</p>
            </div>

            <div v-show="issue === 'quantities'">
                <!--<span class="icon-error paddingWarning red textAlignCenter font42 column10"></span>-->
                <h3 class="layout__padding-20-0">No matching quantity results for selections:</h3>
                <p>Product: {{printJob.printJobSpec.name}}</p>
                <p>Paper Weight: {{printJob.printJobSpec.stockWeight}}</p>
                <p>Lamination: {{printJob.printJobSpec.lamination}}</p>
            </div>

            <div v-show="issue === 'artworkChecks'" class="padding">
                We have checked your artwork and it does not match the product you are looking for, please re-select your product options
            </div>

            <div class="layout__padding-20-0">

                <div class="">
                    <el-button class="button__base layout__width-200px button-red layout__position-center" v-on:click="back()">Revise Print
                        Options
                    </el-button>
                </div>

                <div class="">

                    <div class="layout__padding-20-0">
                        <p>Please contact our team who will be happy to review your template<br> and enable you to print
                            with
                            us.</p>
                        <div class="layout__padding-20-0">
                            <p>Ravensworth Client Services:</p>
                            <p class="text__colour-teal">0191 917 9331</p>
                            <p class="text__colour-teal">client.support@ravensworth.co.uk</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Router from '../../../router';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "noresultsfound",
        components: {},
        props: {
            printJob: Object,
            searchParams: Object,
            issue: ''
        },
        data() {
            return {}
        },
        mixins: [axios, dataFormatter, backing],
        created() {
        },
        methods: {
            back() {

                const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.printJob.id + '?resetJobSpec=true'


                const emptyJobSpec = {
                    "printJobSpec": {}
                }

                Axios.put(url, emptyJobSpec, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data

                        if (this.issue === 'types') {
                            Router.push({
                                name: '/instant-print/products',
                                params: {
                                    printJob: this.printJob,
                                    searchParams: this.searchParams
                                }
                            });
                        } else {
                            Router.push({
                                name: '/instant-print/print-selections',
                                params: {
                                    printJob: this.printJob,
                                    searchParams: this.searchParams
                                }
                            });
                        }
                    })
            }
        }
    };
</script>
